import { BaseTxRedeemer } from '../../Entities/index.exports';
import { toPlutusDataInvestUnitType } from '../conversions';
import { Convertible, type POSIXTime } from '../index.exports';
import type { TokensForInvestUnitDatum } from '../types';

export type FundHoldingPolicyRedeemer = FundHoldingPolicyRedeemerMintID | FundHoldingPolicyRedeemerBurnID;

export class FundHoldingPolicyRedeemerMintID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
}

export class FundHoldingPolicyRedeemerBurnID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export type FundHoldingValidatorRedeemer =
    | FundHoldingValidatorRedeemerUpdateMinADA
    | FundHoldingValidatorRedeemerDeposit
    | FundHoldingValidatorRedeemerWithdraw
    | FundHoldingValidatorRedeemerCollect_Protocol_Commission
    | FundHoldingValidatorRedeemerCollect_Managers_Commissions
    | FundHoldingValidatorRedeemerCollect_Delegators_Commissions
    | FundHoldingValidatorRedeemerReIndexing
    | FundHoldingValidatorRedeemerBalanceAssets
    | FundHoldingValidatorRedeemerEmergency
    | FundHoldingValidatorRedeemerDelete;

export class FundHoldingValidatorRedeemerUpdateMinADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
}

export class FundHoldingValidatorRedeemerDeposit extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rdDate!: POSIXTime;

    @Convertible({ isForRedeemer: true })
    rdAmount!: bigint;
}

export class FundHoldingValidatorRedeemerWithdraw extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rwDate!: POSIXTime;

    @Convertible({ isForRedeemer: true })
    rwAmount!: bigint;

    @Convertible({ isForRedeemer: true })
    rwAmountPlusCommissions!: bigint;
}

export class FundHoldingValidatorRedeemerCollect_Protocol_Commission extends BaseTxRedeemer {
    protected static _plutusDataIndex = 3;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rcpcDate!: POSIXTime;

    @Convertible({ isForRedeemer: true })
    rcpcAmount!: bigint;
}

export class FundHoldingValidatorRedeemerCollect_Managers_Commissions extends BaseTxRedeemer {
    protected static _plutusDataIndex = 4;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rcmcDate!: POSIXTime;

    @Convertible({ isForRedeemer: true })
    rcmcAmount!: bigint;
}

export class FundHoldingValidatorRedeemerCollect_Delegators_Commissions extends BaseTxRedeemer {
    protected static _plutusDataIndex = 5;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rcdcDate!: POSIXTime;

    @Convertible({ isForRedeemer: true })
    rcdcAmount!: bigint;
}

export class FundHoldingValidatorRedeemerReIndexing extends BaseTxRedeemer {
    protected static _plutusDataIndex = 6;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, toPlutusData: toPlutusDataInvestUnitType })
    rriTokensToAdd!: TokensForInvestUnitDatum;

    @Convertible({ isForRedeemer: true, toPlutusData: toPlutusDataInvestUnitType })
    rriTokensToRemove!: TokensForInvestUnitDatum;
}

export class FundHoldingValidatorRedeemerBalanceAssets extends BaseTxRedeemer {
    protected static _plutusDataIndex = 7;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rbCommissionsFT!: bigint[]; // Commission movements between holdings
}

export class FundHoldingValidatorRedeemerEmergency extends BaseTxRedeemer {
    protected static _plutusDataIndex = 8;
    protected static _plutusDataIsSubType = true;
}

export class FundHoldingValidatorRedeemerDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 9;
    protected static _plutusDataIsSubType = true;
}
